<script lang="ts" setup>
import { ref } from 'vue';
import MembershipGroup, { Group } from './MembershipBlock/Group.vue';
import Container from '~/components/Container.vue';
import Tabs from '~/components/ui/Tabs.vue';

interface Props {
  anchor?: string;
  title?: string;
  groups: Group[];
}

const props = defineProps<Props>();

const currentTab = ref<Group>(props.groups[0]);
</script>

<template>
  <section v-if="groups && groups.length > 0" :id="anchor" class="membership">
    <Container class="membership__container">
      <div class="membership__heading">
        <h2 v-if="title" class="membership__title">{{ title }}</h2>
        <div class="membership__buttons">
          <Tabs v-model:current-tab="currentTab" :tabs="groups" class="tabs-block__tabs" />
        </div>
      </div>
      <div class="membership__body">
        <MembershipGroup :current-tab="currentTab" :group="currentTab" />
      </div>
    </Container>
  </section>
</template>

<style lang="scss" scoped>
.membership {
  @apply my-10 overflow-hidden;
  @apply md:my-16;
  @apply xl:my-24;

  &__heading {
    @apply flex flex-col gap-8 items-center w-full mb-10;
    @apply xl:flex-row xl:justify-between xl:max-w-[calc(100%-150px)];
  }

  &__title {
    @apply font-semibold leading-[1.1] text-[24px] text-center;
    @apply xl:text-start;
    @apply 2xl:text-[30px];
    @apply 3xl:text-[38px];
  }

  &__buttons {
    @apply w-full;
    @apply xl:w-fit;
  }
}
</style>
